// extracted by mini-css-extract-plugin
export default {"pulse":"pulse-8ed9","pulse-animation":"pulse-animation-ff0f"};